import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScoraToastModuleComponent } from './scora-toast-module.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ScoraToastModuleComponent],
  exports:[ScoraToastModuleComponent]
})
export class ScoraToastModuleModule { }



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-toast-module/scora-toast-module.module.ts